/**
 * Search actions.
 * @module actions/searchResult/searchResult
 */

import { compact, concat, isArray, join, map, pickBy, toPairs } from 'lodash';

import {
  RESET_SEARCH_RESULT_CONTENT,
  SEARCH_RESULT_CONTENT,
} from '../../constants/ActionTypes';

/**
 * Search content function.
 * @function searchContent
 * @param {string} url Url to use as base.
 * @param {Object} options Search options.
 * @param {string} subrequest Key of the subrequest.
 * @returns {Object} Search content action.
 */
export function getSearchResult(url, options, subrequest = null) {
  let queryArray = [];
  // console.log({ searchContent: options });

  const arrayOptions = pickBy(options, (item) => isArray(item));

  queryArray = concat(
    queryArray,
    options
      ? join(
          map(toPairs(pickBy(options, (item) => !isArray(item))), (item) => {
            if (item[0] === 'q') {
              // Adds the wildcard to the q param
              // NOTE: & で検索可能にするための修正 by karad
              // item[1] = `${item[1]}`;
              item[1] = encodeURIComponent(encodeURIComponent(item[1]));
            }
            return join(item, '=');
          }),
          '&',
        )
      : '',
  );

  queryArray = concat(
    queryArray,
    arrayOptions
      ? join(
          map(pickBy(arrayOptions), (item, key) =>
            join(
              item.map((value) => `${key}:list=${value}`),
              '&',
            ),
          ),
          '&',
        )
      : '',
  );

  // queryArray.push(`lang=${Locale.getLocale()}`)

  const querystring = join(compact(queryArray), '&');

  return {
    type: SEARCH_RESULT_CONTENT,
    subrequest,
    request: {
      op: 'get',
      path: `/@search-result${querystring ? `?${querystring}` : ''}`,
    },
  };
}

/**
 * Reset search content function.
 * @function resetSearchContent
 * @param {string} subrequest Key of the subrequest.
 * @returns {Object} Search content action.
 */
export function resetSearchResult(subrequest = null) {
  return {
    type: RESET_SEARCH_RESULT_CONTENT,
    subrequest,
  };
}
